import Phrase from 'libs/translationsUtils/phrase'

const HitContainerHeader = ({ inputValue, hasResults, doSearch }) =>
  <div className='algolia-hit-container__header'>
    <a onClick={() => doSearch(inputValue)} className='algolia-search-submit-link'>
      <span className='algolia-hit-container__header-text'>
        {
          inputValue ? (
            hasResults
              ? <Phrase p='live.search.search.text' />
              : <Phrase p='live.search.no.result.found.text' />
          ) : <Phrase p='live.search.trending.text' />
        }
      </span>
      {' '}
      {inputValue}
    </a>
  </div>

export default HitContainerHeader
